import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import Swal from "sweetalert2";
import baseUrl from "../utilities/baseUrl";
import useSharedData from "./useSharedData";

const usePDFDownload = ({
  body = undefined,
  params = undefined,
  url = "",
  method = "POST",
  onSuccess = () => {},
  onError = () => {},
}) => {
  const { user } = useSharedData();
  const streamPDF = user?.isStreamingPDF ? true : false;
  const token = localStorage.getItem("token");

  const onSuccessResponse = data => {
    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );

    if (streamPDF === true) {
      window.open(url, "_blank");
    } else {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "factor");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    URL.revokeObjectURL(url);
    onSuccess();
  };

  const onErrorResponse = async error => {
    let message = "";

    try {
      const object = JSON.parse(await error.response.data.text());
      message = object.message;
    } catch (error) {
      message = "در ارتباط با سرور با خطا مواجه شدیم";
    }

    Swal.fire({
      icon: "error",
      text: message,
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "red",
    }).then(() => onError());
  };

  const { mutate, isPending } = useMutation({
    mutationKey: ["label-pdf"],
    mutationFn: values =>
      axios
        .request({
          baseURL: baseUrl,
          url,
          data:
            values || body ? { ...(values || {}), ...(body || {}) } : undefined,
          params,
          method,
          headers: {
            Authorization: "Bearer " + token,
          },
          responseType: "blob",
        })
        .then(res => res.data),

    onSuccess: onSuccessResponse,
    onError: onErrorResponse,
  });

  return { mutate, isPending };
};

export default usePDFDownload;
